import { generateGuid } from './utils/guid-utils';

export const VIEWER_SESSION_ID_KEY = 'wixViewerSessionId';

let viewerSessionId: string | undefined;

// Kept in sessionStorage because headless sites are multi-page: a per-load id would make every page view its own session.
export const getViewerSessionId = () => {
  if (viewerSessionId) {
    return viewerSessionId;
  }

  try {
    viewerSessionId =
      sessionStorage.getItem(VIEWER_SESSION_ID_KEY) ?? undefined;

    if (!viewerSessionId) {
      viewerSessionId = generateGuid();
      sessionStorage.setItem(VIEWER_SESSION_ID_KEY, viewerSessionId);
    }
  } catch {
    // sessionStorage is unavailable (e.g. blocked), fall back to a per-load id
    viewerSessionId ??= generateGuid();
  }

  return viewerSessionId;
};

export const resetViewerSessionId = () => {
  viewerSessionId = undefined;
};
